import { render, staticRenderFns } from "./CreateEditLojaModal.vue?vue&type=template&id=3f12bcb7&"
import script from "./CreateEditLojaModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditLojaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports